import { ReactNode } from 'react';
import { Breadcrumbs, styled, Typography } from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { format } from 'date-fns';
import { IMemberDetails } from '@types';
import { useIsPhone } from '@hooks';
import { touchHitAreaSx } from 'theme/touchTarget';

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.link,
}));

const BackLink = ({ to, children }: { to: string; children: ReactNode }) => (
  <StyledLink to={to}>
    <ArrowBack sx={{ fontSize: 14, transform: 'translateY(2px)', mr: 1 }} />
    {children}
  </StyledLink>
);

export const DynamicBreadcrumbs = ({ data }: { data: IMemberDetails }) => {
  const location = useLocation();
  const { memberId } = useParams();
  const isPhone = useIsPhone();

  const happinessMatch = location.pathname.match(/\/happiness/);
  const evalsMatch = location.pathname.match(/\/evaluations$/);
  const evalMatch = location.pathname.match(/\/evaluations\/([^/]+)/);
  const evalId = evalMatch ? evalMatch[1] : null;

  const evaluation = evalId
    ? data.member.evaluations.find((evalItem) => evalItem.id === evalId)
    : null;

  const evaluationsPath = `/teams/${data.project.id}/members/${memberId}/evaluations`;

  if (isPhone)
    return (
      <Breadcrumbs sx={{ mb: 2, '& a': touchHitAreaSx }}>
        <BackLink to={evalMatch ? evaluationsPath : '/teams'}>
          {evalMatch ? data.member.fullName : data.project.account.name}
        </BackLink>
      </Breadcrumbs>
    );

  return (
    <Breadcrumbs sx={{ mb: 2 }}>
      <BackLink to="/teams">{data.project.account.name}</BackLink>
      <StyledLink to={`/teams`}>{data.project.name}</StyledLink>
      <StyledLink to={`/teams/${data.project.id}/members/${memberId}`}>
        {data.member.fullName}
      </StyledLink>
      {evalMatch && <StyledLink to={evaluationsPath}>Evaluations</StyledLink>}
      {evalsMatch && <Typography>Evaluations</Typography>}
      {happinessMatch && <Typography>Happiness</Typography>}
      {evaluation && (
        <Typography>
          {format(new Date(evaluation.evaluationDate), 'MMMM yyyy')}
        </Typography>
      )}
    </Breadcrumbs>
  );
};
